import { getFilterStore } from '../store/FilterStore';

export function getFilterString() {
    const dateString = getFilterStore().dateRangeFilter.selectedValue.dateRange
        ? getFilterStore().dateRangeFilter.selectedValue.dateRange.endDate.toString() +
          getFilterStore().dateRangeFilter.selectedValue.dateRange.startDate.toString()
        : '';

    const extensionString = getFilterStore().extensionGroupFilter.selectedValue.size
        ? getFilterStore().extensionGroupFilter.selectedValue.toString()
        : '';

    const columnSortString = getFilterStore().columnSort.selectedValue.toString();

    return extensionString + dateString + columnSortString;
}
